import React from 'react';
import Block from '../Block/Block';
var InfoPage = function (props) {
    var backgroundSrc = props.backgroundSrc, _a = props.hideIcon, hideIcon = _a === void 0 ? false : _a, iconClass = props.iconClass, blockClass = props.blockClass, children = props.children, className = props.className;
    var getBackgroundImageStyle = function () {
        return backgroundSrc ? { backgroundImage: "url('" + backgroundSrc + "')" } : {};
    };
    return (React.createElement("div", { className: "info-page" + (className ? " " + className : ''), style: getBackgroundImageStyle() },
        React.createElement(Block, { shadow: true, background: "white", customClass: "info-page-block " + blockClass },
            React.createElement("div", { className: "d-flex flex-column flex-sm-row align-items-center" },
                !hideIcon && iconClass && (React.createElement("div", { className: "info-page-icon" },
                    React.createElement("i", { className: "fal " + iconClass }))),
                React.createElement("div", { className: "info-page-content" }, children)))));
};
export default InfoPage;
